import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["board", "column"]
  static values = {
    updateUrl: String
  }

  connect() {
    if (this.hasBoardTarget) {
      this.handleWheel = this.handleWheel.bind(this)
      this.boardTarget.addEventListener("wheel", this.handleWheel, { passive: false })
    }
    this.initSortable()
  }

  disconnect() {
    if (this.hasBoardTarget && this.handleWheel) {
      this.boardTarget.removeEventListener("wheel", this.handleWheel)
    }
    if (this.sortables) {
      this.sortables.forEach(s => s.destroy())
    }
  }

  initSortable() {
    this.sortables = []
    this.columnTargets.forEach((column) => {
      const sortable = Sortable.create(column, {
        group: "tasks",
        animation: 150,
        ghostClass: "opacity-50",
        dragClass: "shadow-lg",
        // forceFallback = bypass drag HTML5 natif (ghost-URL navigateur sur les cartes <a>)
        forceFallback: true,
        fallbackOnBody: true,
        onEnd: this.onDragEnd.bind(this)
      })
      this.sortables.push(sortable)
    })
  }

  onDragEnd(event) {
    const taskId = event.item.dataset.taskId
    const targetStatus = event.to.dataset.status
    const targetDate = event.to.dataset.date

    if (!taskId) return
    if (!targetStatus && !targetDate) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const taskData = {}

    if (targetStatus) {
      taskData.status = targetStatus
      if (targetStatus === "in_progress") {
        taskData.due_date = new Date().toISOString().split("T")[0]
      }
    }

    if (targetDate) {
      taskData.due_date = targetDate
    }

    fetch(`/tasks/${taskId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({
        task: taskData,
        redirect_to: "mon_jour"
      })
    })
  }

  handleWheel(event) {
    const board = this.boardTarget
    if (board.scrollWidth <= board.clientWidth) return

    const scrollableColumn = event.target.closest(".overflow-y-auto")
    if (scrollableColumn && Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
      event.preventDefault()
      scrollableColumn.scrollTop += event.deltaY
      return
    }

    if (Math.abs(event.deltaX) < Math.abs(event.deltaY)) {
      event.preventDefault()
      board.scrollLeft += event.deltaY
    }
  }
}
